import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MergeInfoModel } from '../models/merge-info.model';
import { Observable, of } from 'rxjs';
import { UrlService } from 'app/core/http/url.service';
import { ValidatedMergeCandidate } from '../models/validated-merge-candidate.model';

@Injectable({
  providedIn: 'root'
  })
export class MergeAccountDataService {
  public constructor(private readonly httpClient: HttpClient,
                private readonly urlService: UrlService) {}


  public validateMergeCandidate(email: string, password: string): Observable<ValidatedMergeCandidate> {
    const url = this.urlService.buildServerApiUrl('teacher', 'mergeaccount', 'check');

    return this.httpClient.post<ValidatedMergeCandidate>(url, { password, teacherToMergeEmail: email })
  }

  public sendMergeAccountEmail(email: string): Observable<void> {

    const url = this.urlService.buildServerApiUrl('teacher', 'mergeaccount');

    return this.httpClient.post<void>(url, {teacherToMergeEmail: email});
  }

  public getMergeInfo(destination: string): Observable<MergeInfoModel> {
    const url = this.urlService.buildServerApiUrl('teacher', 'getmergeinfo');
    const queryParams = new HttpParams().append('destination', destination);

    return this.httpClient.get<MergeInfoModel>(url, { params: queryParams });
  }

  public mergeAccount(destination: string): Observable<void> {
    const url = this.urlService.buildServerApiUrl('teacher', 'mergeaccount', 'confirm')

    return this.httpClient.post<void>(url, {destinationTeacherId: destination});
  }
}
